class Candidate {
	id = null;
	first_name = '';
	last_name = '';
	oib = '';
	date_of_birth = null;
	place_of_birth = '';
	country_of_birth_id = null;
	address = '';
	postal_code = null;
	city = '';
	county_id = null;
	country_id = null;
	phone = '';
	email = '';
	partner_id = null;
	rank_id = null;
	id_card_or_passport_number = null;
	remark = null;
	candidate = {};
	loyalty_points = 0;
	loyalty_card = null;
	gdpr_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};
	loyalty_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};
	loyalty_consent = false;
	gdpr_consent = false;
	notifications = false;
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Candidate;
